import './scripts/common';


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


/**********************************
 *
 *      Site Stuff
 *
 * ********************************/

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as actionChanger from '@elements/action-changer';
actionChanger.init();

import * as locationMapLeaflet from './scripts/location-map-leaflet';
locationMapLeaflet.init();